export const FETCHING_COUNTRIES = 'FETCHING_COUNTRIES';
export const FETCHING_COUNTRIES_SUCCESSFUL = 'FETCHING_COUNTRIES_SUCCESSFUL';
export const FETCHING_COUNTRIES_FAILED = 'FETCHING_COUNTRIES_FAILED';

export const FETCH_USERS_COUNTRY = 'FETCH_USERS_COUNTRY';
export const FETCH_USERS_COUNTRY_FAILED = 'FETCH_USERS_COUNTRY_FAILED';
export const FETCH_USERS_COUNTRY_SUCCESS = 'FETCH_USERS_COUNTRY_SUCCESS';

export const FETCH_COUNTRY_DONATION_SUMMARY = 'FETCH_COUNTRY_DONATION_SUMMARY';
export const FETCH_COUNTRY_DONATION_SUMMARY_FAILED = 'FETCH_COUNTRY_DONATION_SUMMARY_FAILED';
export const FETCH_COUNTRY_DONATION_SUMMARY_SUCCESS = 'FETCH_COUNTRY_DONATION_SUMMARY_SUCCESS';

export const FETCH_COUNTRY_SLIDER_STATE = 'FETCH_COUNTRY_SLIDER_STATE';
export const FETCH_COUNTRY_SLIDER_STATE_SUCCESS = 'FETCH_COUNTRY_SLIDER_STATE_SUCCESS';
export const FETCH_COUNTRY_SLIDER_STATE_FAILED = 'FETCH_COUNTRY_SLIDER_STATE_FAILED';

export const FETCH_ACTIVE_COUNTRY_FROM_STORYBLOK = "FETCH_ACTIVE_STORY_FROM_STORY_BLOK";
export const FETCH_ACTIVE_COUNTRY_FROM_STORYBLOK_SUCCESS = "FETCH_ACTIVE_STORY_FROM_STORY_BLOK_ACTIVE";
export const FETCH_ACTIVE_COUNTRY_FROM_STORYBLOK_FAILED = "FETCH_ACTIVE_STORY_FROM_STORY_BLOK_FAILED";

export const FETCH_VACCINATIONS = "FETCH_VACCINATIONS";
export const FETCH_VACCINATIONS_FAILED = "FETCH_VACCINATIONS_FAILED";
export const FETCH_VACCINATIONS_SUCCESS = "FETCH_VACCINATIONS_SUCCESS";
